export enum ATTRIBUTES {
  FONT_SIZE = 'data-font-size',
  FONT_WEIGHTS = 'data-font-weight',
  HIGH_LIGHT = 'data-highlight',
  BOXED_TEXT = 'data-boxed-text',
}

export const TEXT_ALIGN = ['left', 'center', 'right'];
